import UpdateCreditCardModal from './UpdateCreditCardModal';

export default UpdateCreditCardModal;
